module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "x9781590207048-3.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    staticStyle: {
      "margin": "15%"
    }
  }, [_c('p', {
    staticClass: "Dedication-Text",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_vm._v("To A."), _c('br'), _vm._v("J."), _c('br'), _vm._v("M."), _c('br'), _vm._v("and a “four”")]), _vm._v(" "), _c('p', {
    staticClass: "Dedication-Text"
  }, [_vm._v("without any of whom, "), _c('br'), _vm._v("no book.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c853f4f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781590207048-3.vue
// module id = 69
// module chunks = 0